import React, { useEffect, useState } from "react";
import { set_order_detail } from "../../../../redux/actions/OrdersAction";
import { connect } from "react-redux";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import $ from "jquery";
import "./shipmentitem.scss";
import { format } from "date-fns";
import CreateModal from "../../../../components/modal/CreateModal";
import { getDesktopImage } from "../../../../utils/utils";

const ShipmentItem = (props) => {
  const [showModal, setshowModal] = useState(false);

  const handleButtonClick = () => {
    setshowModal(true);
  };

  useEffect(() => {
    if (showModal) {
      $(".right").css("overflow", "hidden");
    } else {
      $(".right").css("overflow", "auto");
    }
  }, [showModal]);
  const { shipmentItem } = props;
  return (
    <Row className="shipment-item-desktop g-0">
      <div className="image-container product-box-padding d-flex justify-content-center">
        {(shipmentItem?.featured_image_resized ||
          shipmentItem?.featured_image) && (
          <img
            style={{
              width: "auto",
              maxWidth: "100%",
              height: "100%",
            }}
            src={getDesktopImage(
              shipmentItem?.featured_image_resized,
              shipmentItem?.featured_image
            )}
            alt=""
          />
        )}
      </div>

      <Col className="details py-2">
        <Row className="g-0 px-2 h-100">
          <Col md={10} className="h-100 position-relative">
            <Row className="g-0 h-100">
              <div className="detail-wrapper d-flex flex-column justify-content-between">
                <div className="upper">
                  <Col md={12} className="col-padding">
                    {shipmentItem?.brand_name_en && (
                      <span
                        className="brand text-gray me-2"
                        style={{ color: "grey" }}
                      >
                        {shipmentItem.brand_name_en &&
                          shipmentItem.brand_name_en}
                      </span>
                    )}
                    <span className="title">
                      {shipmentItem?.orderable_type === "Service" &&
                        shipmentItem?.name_en}
                      {shipmentItem?.orderable_type === "Product" &&
                        shipmentItem?.product_name_en +
                          " " +
                          shipmentItem?.variant_name_en}
                    </span>
                  </Col>
                  {shipmentItem?.sku && (
                    <Col md={12} className="col-padding">
                      <span
                        className="brand gray-text"
                        style={{ color: "grey" }}
                      >
                        {shipmentItem?.sku}
                      </span>
                    </Col>
                  )}
                  <Col md={12} className="col-padding">
                    <span
                      className="brand gray-text pb-2"
                      style={{ fontWeight: "600" }}
                    >
                      Status:
                    </span>
                    <span className="shipment-status text-uppercase ms-2">
                      {shipmentItem?.status}
                    </span>
                  </Col>
                  {shipmentItem.start_at && (
                    <Col md={12} className="col-padding">
                      <span className="start-date me-1">Starts At</span>
                      <span className="date ms-1">
                        {format(
                          Date.parse(shipmentItem.start_at),
                          "dd MMM yyy p"
                        )}
                      </span>
                    </Col>
                  )}
                  {shipmentItem.end_at && (
                    <Col md={12} className="col-padding">
                      <span className="start-date me-1">Ends At</span>
                      <span className="date ms-1">
                        {format(
                          Date.parse(shipmentItem.end_at),
                          "dd MMM yyy p"
                        )}
                      </span>
                    </Col>
                  )}
                </div>
                <div className="lower">
                  <Col md={12} className="sold-by faded-black-2-text">
                    Sold by
                    <span className="ms-2 fw-bold">
                      {shipmentItem.store_name_en}
                    </span>
                  </Col>
                </div>
              </div>
            </Row>
          </Col>

          <Col md={2} className="d-flex flex-column justify-content-between">
            <Row className="g-0 text-end">
              <Col
                md={12}
                className="price faded-black-2-text text-nowrap text-uppercase"
              >
                {props.currency ? props.currency : ""}
                <span className="fw-bold ms-1">{shipmentItem.price}</span>
              </Col>

              {shipmentItem.quantity && (
                <Col md={12} className="quantity gray-text">
                  {shipmentItem.quantity}
                  {shipmentItem.quantity > 1 ? "units" : "unit"}
                </Col>
              )}
            </Row>
            {shipmentItem &&
              shipmentItem.status &&
              shipmentItem.status.toLowerCase() === "delivered" && (
                <Row className="g-0 d-flex justify-content-end">
                  <button
                    type="button"
                    className="create-dispute"
                    onClick={handleButtonClick}
                  >
                    Create Dispute
                  </button>
                  {showModal && (
                    <div className="modal-wrapper">
                      <CreateModal
                        heading="Create Dispute"
                        orderNo="A7231g"
                        item="Item 1"
                        onCancle={() => setshowModal(false)}
                        onCreate={() => setshowModal(false)}
                        orderDetail={props.orderDetail}
                        itemDetail={shipmentItem}
                      />
                    </div>
                  )}
                </Row>
              )}
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

const mapStateToProps = (state) => {
  return {
    orderDetail: state.order.orderDetail,
  };
};

const mapDispatchToProps = { set_order_detail };

export default connect(mapStateToProps, mapDispatchToProps)(ShipmentItem);
